const API_BASE = "https://wp.lokchemicals.in/api";

const UserDataApi = {
  USER_GET_RECORD: `${API_BASE}/records`,
  USER_POST_REQUEST: `${API_BASE}/request`,
  USER_POST_HISTORY: `${API_BASE}/history`,
};

export default UserDataApi;
